import React, { useEffect, useState } from 'react';
import { Box, Flex, Text } from "@chakra-ui/layout";
import { Image, Input } from "@chakra-ui/react";
import FileViewer from 'react-file-viewer';
import Send from "../../../images/class/send.svg";
import socket from "../../../utilities/socket";
import { useSelector } from 'react-redux';
import { StateType } from '../../../store/store';
import Swal from 'sweetalert2';

type room = {
  userName: string, role: string, room: string
}

type Props = {
  roomName: string
}

function Facilities({ roomName }: Props) {
  const {
    teacherReducer: { data: { username, role } },
    studentReducer
  } = useSelector((state: StateType) => state.rootReducer);
  const [note, setNote] = useState<string>("");
  const [noteType, setNoteType] = useState<string>("");
  const [noteInput, setNoteInput] = useState<string>("");
  const [noteTypeInput, setNoteTypeInput] = useState<string>("");
  const [input, setInput] = useState<string>("");
  const [receivedMessage, setReceivedMessage] = useState<{ message: string, name: string }>({ message: "", name: "" });
  const [liveClasses, setLiveClasses] = useState<{ [key: string]: { time: string, className: string, users: room[] } }>({})
  const [length, setLength] = useState<number>(0);
  const [users, setUsers] = useState<room[]>([]);
  const [chats, setChats] = useState<JSX.Element[]>([]);

  useEffect(() => {
    socket.on("notesData", (_notes, _noteType) => {
      console.log(_notes, _noteType)
      setNoteInput(_notes);
      setNoteTypeInput(_noteType);
    });
    socket.on("sendMessage", (data) => {
      console.log(data)
      setReceivedMessage(data)
    })
  })

  useEffect(() => {
    if (note !== "" && noteType !== "") {
      socket.emit("notes-data", note, noteType)
    }
  }, [note, noteType])

  useEffect(() => {
    if (receivedMessage.message !== "") {
      window.scrollTo(0, document.body.scrollHeight);
      let Chat = (
        <Flex className="message__container" alignItems="flex-start">
          <Flex className="message__container-message">{receivedMessage.message}</Flex>
          <Flex>{receivedMessage.name}</Flex>
        </Flex>
      )
      setChats([...chats, Chat])
    }
  }, [receivedMessage])

  socket.on("live-class", (classes) => {
    //console.log(classes);
    setLiveClasses(classes);
  })

  useEffect(() => {
    if (liveClasses[roomName]) {
      setUsers(liveClasses[roomName].users)
      setLength(liveClasses[roomName].users.length)
    }

  }, [liveClasses])

  async function sendMessage() {
    if (input.trim() === "") {
      return await Swal.fire({
        icon: "error",
        text: "Enter a message before you send"
      })
    }
    console.log(input)
    let Chat = (
      <Flex className="message__container" alignItems="flex-end">
        <Flex className="message__container-message">{input}</Flex>
        <Flex>you</Flex>
      </Flex>
    )
    setChats([...chats, Chat]);
    const name = studentReducer.data.username === "" ? username : studentReducer.data.username;
    socket.emit("message", { message: input, name: name });
    setInput("")
  }

  return (
    <Flex w={"100%"} p={4} mb={"100px"} flexDirection={{ base: "column", md: "row" }}>
      <Flex boxShadow="2xl" flexDirection={"column"} w={"100%"} mb={{ base: 7, lg: 20 }} borderRadius={"20px"}>
        <Text textTransform={"capitalize"} textAlign={"center"} fontWeight={"bold"} fontSize={"2xl"}
          my={3}>Notes</Text>
        {role === "teacher" && (
          <Flex px={4}>
            <Input mx={"auto"} w={"80%"} type={"text"} value={note}
              onChange={(e) => setNote(e.target.value)}
              placeholder={"paste url link to note"} />
            <Input mx={"auto"} w={"80%"} type={"text"} value={noteType}
              onChange={(e) => setNoteType(e.target.value)}
              placeholder={"put file extension"} />
          </Flex>
        )}
        <FileViewer fileType={noteTypeInput} filePath={noteInput} />
      </Flex>
      <Flex flexDirection={"column"} p={3} mb={20} w={"100%"}>
        <Flex bgColor={"white"} borderRadius={"20px"} p={8} boxShadow="2xl" height={"65px"} justifyContent={"center"}
          alignItems={"center"}>
          <Text textTransform={"capitalize"} fontWeight={"extrabold"} fontSize={"2xl"}>
            {length}{" "}Participants <br />
          </Text>
        </Flex>
        <Box justifyContent={"space-between"} bgColor={"white"} borderRadius={"20px"} p={5} mt={6} boxShadow="2xl"
          height={"600px"} pos={"relative"}>
          <Text textTransform={"capitalize"} fontWeight={"extrabold"} fontSize={"2xl"} mb={"20px"}>Messages</Text>
          <Box mx={4} h={"80%"} mb={"70px"} overflowY={"auto"}>
            <Flex flexDirection={"column"} w={"100%"} id={"chat-area"}>
              {chats.map((chat, index) => (
                <Box key={index}>
                  {chat}
                </Box>
              ))
              }
            </Flex>
          </Box>
          <Flex pos={"relative"}>
            <Input type={"text"} w={"100%"} mt={4} pr={"40px"} pos={"absolute"} bottom={"10px"} mx={"auto"} zIndex={2}
              placeholder={"Send a message"} value={input} onChange={(e) => setInput(e.target.value)}
            />
            <Box bgColor={"brand.gold"} borderRadius={"50%"} p={2} pos={"absolute"} bottom={"90%"} right="8px"
              mb={"12.5px"} cursor={"pointer"} onClick={() => sendMessage()} zIndex={"4"}>
              <Image
                title={"send"}
                src={Send}
                alt={"send button"}
                boxSize={"20px"}
              />
            </Box>
          </Flex>
        </Box>
      </Flex>
    </Flex>
  )
}

export default Facilities;